var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-button"},[_c('button',{staticClass:"child",style:({
      width: _vm.width,
      height: _vm.height,
      backgroundColor: _vm.backgroundColor,
      color: _vm.color
    }),on:{"click":function($event){$event.stopPropagation();return _vm.model($event)}}},[_c('span',[_vm._v(_vm._s(_vm.text))])])])}
var staticRenderFns = []

export { render, staticRenderFns }